import { type TeamLogo } from '@prisma/client'

export function TeamLogo({
  logo,
  className,
}: {
  logo?: Pick<TeamLogo, 'id' | 'altText'> | null
  className?: string
}) {
  if (logo == null) {
    return null
  }

  return (
    <img className={className} src={`/resources/team-logo/${logo.id}`} alt={logo.altText ?? ''} />
  )
}
